export enum ValidationMessages {
  REQUIRED = 'required',
  INVALID = 'invalid',
  MINIMUM = 'minimum',
  MAXIMUM = 'maximum',
  NOTMATCHING = 'notmatching',
}

export enum IdNowUserFieldStatus {
  CHANGED = "changed",
  MATCH = "match",
  NEW = "new",
}

export enum IdTypes {
  ID = 'id',
  PASSPORT = 'passport',
}

export enum AssetTypes {
  REAL_ESTATE = 'real_estate',
  LOAN = 'loan',
}

export enum EducationLevel {
  PRIMARY_EDUCATION = "primary_education",
  SECONDARY_EDUCATION = "secondary_education",
  ACADEMIC_DEGREE = "academic_degree",
  PROFESSIONAL_DEVELOPMENT = "professional_development",
  OTHER = "other",
}

export enum ExperienceType {
  EQUITY = 'equity',
  STOCKS = 'stocks',
  BONDS_CERTIFICATES = 'bonds_certificates',
  INVESTMENTS = 'investments',
  PARTICIPATIONS = 'participations',
  SUBORDINATED_LOANS = 'subordinated_loans',
}

export enum ExperienceLevel {
  NONE = 'none',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum FileExtensions {
  JPEG = 'jpeg',
  PNG = 'png',
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
}

export enum IdNowStatus {
  NEEDS_APPROVAL = "needs_approval",
  CREATED = "created",
  SUCCESS = "success",
  FRAUD_SUSPICION_CONFIRMED = "fraud_suspicion_confirmed",
}

export enum InvestmentStatusValues {
  AWAITING_PAYMENT = 'awaiting_payment',
  CONFIRMED = 'confirmed',
  REVOKE_REQUESTED = 'revoke_requested',
  REVOKED = 'revoked',
  CANCELED = 'canceled',
  REFUNDED = 'refunded',
  UNPAID = 'unpaid',
}

export enum InvestmentSelector {
  ALL = 'all',
}

export type InvestmentFilter = InvestmentStatusValues | InvestmentSelector;

export enum MimeTypes {
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_PNG = 'image/png',
}

export enum OccupationGroup {
  PRIVATIER = "privatier",
  APPRENTICE = "apprentice",
  PENSIONER = "pensioner",
  STUDENT = "student",
  SELF_EMPLOYED = "self_employed",
  CIVIL_SERVANT = "civil_servant",
  EMPLOYEE = "employee",
}

export enum SaleStatus {
  ACTIVE = 'active',
  SOLDOUT = 'soldout',
  MANUAL = 'manual',
  FINISHED_DATE = 'finished_date',
}

export enum SaleInterestPayoutPeriod {
  QUARTERLY = 'quarterly',
  BIANNUAL = 'biannual',
  YEARLY = 'yearly',
}

export enum SortSalesBy {
  RECENTLY_STARTED = 'recently_started',
  ALMOST_ENDING = 'almost_ending',
  HIGHEST_INTEREST_RATE = 'highest_interest_rate',
  MOST_SOLDOUT = 'most_soldout',
}

export enum PaymentMethods {
  CREDIT_CARD = 'credit_card',
  SEPA_DIRECT_DEBIT = 'sepa_direct_debit',
  WIRE_TRANSFER = 'wire_transfer',
}

export enum RoleNames {
  USER = 'user',
  ADMIN = 'admin',
  SYSTEM = 'system',
}

export enum WalletStatus {
  ACTIVE = 'active',
  TRANSFERRED = 'transferred',
}

export const isEnumValue = (value: any) => {
  return (
    Object.values(ValidationMessages).includes(value) ||
    Object.values(IdTypes).includes(value) ||
    Object.values(AssetTypes).includes(value) ||
    Object.values(ExperienceType).includes(value) ||
    Object.values(ExperienceLevel).includes(value) ||
    Object.values(FileExtensions).includes(value) ||
    Object.values(InvestmentStatusValues).includes(value) ||
    Object.values(InvestmentSelector).includes(value) ||
    Object.values(MimeTypes).includes(value) ||
    Object.values(SaleStatus).includes(value) ||
    Object.values(SaleInterestPayoutPeriod).includes(value) ||
    Object.values(SortSalesBy).includes(value) ||
    Object.values(PaymentMethods).includes(value) ||
    Object.values(RoleNames).includes(value) ||
    Object.values(WalletStatus).includes(value)
  );
};
